var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,{tag:"component",attrs:{"type":_vm.to ? null : _vm.nativeType,"target":_vm.realTarget,"rel":_vm.realRel,"href":_vm.getHref(),"title":_vm.title,"data-has-no-href":_vm.hasNoHref},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }